angular.module('unergie.main')
.controller('billingModalitiesCtrl', ($scope, $state, $uibModal, DataAccess, ApiUser, BoFeaturesService, AlertManager, TableGeneratorService, ErrorCatcher) => {
    $scope.isActive = (state) => $state.is(state)

    $scope.useTimetable = BoFeaturesService.getModuleFeatures('billingModalities').useTimetable

    $scope.modalities = {
        refreshing: false,
    }

    $scope.modalities.columns = {
        id: { label: 'ID', mode: 'search_wildcard' },
        label: { label: 'Libellé', mode: 'search_wildcard' },
        min_initial_billing_days: { label: 'Nb jours initiale', mode: 'search_operator' },
        min_real_billing_months: { label: 'Nb mois réels', mode: 'search_operator' },
        min_estimated_billing_months: { label: 'Nb mois estimés', mode: 'search_operator' },
        min_intermediate_billing_months: { label: 'Nb mois intermédiaire', mode: 'search_operator' },
        use_timetable: { label: 'Échéancier', mode: $scope.useTimetable ? 'search_wildcard' : 'hidden' },
        priority: { label: 'Priorité', mode: 'search_operator' },
    }

    $scope.delete = (modality) => DataAccess.delModality({ id: modality.id }).$promise.then((data) => $scope.refreshModalities()).catch(ErrorCatcher)


    const modalityTemplate = {
        id: '',
        label: '',
        min_initial_billing_days: 0,
        min_real_billing_months: 0,
        min_estimated_billing_months: 0,
        min_intermediate_billing_months: null,
        use_timetable: $scope.useTimetable,
        priority: 50,
        constraints: {},
        comments: '',
    }

    $scope.modalityFields = {
        id: {
            label: 'ID',
            required: true,
            type: 'text',
        },
        label: {
            label: 'Libellé',
            required: true,
            type: 'text',
        },
        min_initial_billing_days: {
            label: 'Nb jours initiale',
            required: true,
            type: 'number',
        },
        min_real_billing_months: {
            label: 'Nb mois réels',
            required: true,
            type: 'number',
        },
        min_estimated_billing_months: {
            label: 'Nb mois estimés',
            required: true,
            type: 'number',
        },
        min_intermediate_billing_months: {
            label: 'Nb mois intermédiaire',
            type: 'number',
        },
        use_timetable: {
            label: 'Utiliser échéancier',
            type: 'radio',
            enum: [
                { value: true, label: 'Oui' },
                { value: false, label: 'Non' },
            ],
        },
        priority: {
            label: 'Priorité',
            required: true,
            type: 'text',
        },
        comments: {
            label: 'Commentaires',
            type: 'text',
        },
    }

    if (!$scope.useTimetable) {
        delete $scope.modalityFields.use_timetable
    }

    $scope.updateModalityFields = angular.copy($scope.modalityFields)

    const resetModalityPayload = () => {
        $scope.modalityPayload = angular.copy(modalityTemplate)
    }

    resetModalityPayload()

    $scope.addModality = function () {
        const payload = $scope.modalityPayload
        payload.id = payload.id.trim().toUpperCase().replace(/ /g, '_')
        if (!payload.min_intermediate_billing_months) {
            payload.min_intermediate_billing_months = null
        }
        return DataAccess.addModality(payload).$promise.then(() => {
            AlertManager.success('Modalité ajoutée')
            resetModalityPayload()
            return $scope.refreshModalities() }).catch(ErrorCatcher)
    }

    $scope.deleteModality = (mod) =>
        DataAccess.delModality({ id: mod.id }).$promise.then(() => {
            AlertManager.success('Modalité supprimée')
            return $scope.refreshModalities() }).catch(ErrorCatcher)


    $scope.prettyPrint = function (elem) {
        try {
            elem.constraints = JSON.parse(elem.constraints)
        } catch (error) {
            if (error.message.indexOf('at position ') > -1) {
                const start = Number(error.message.split('at position ')[1])
                const textarea = $(`#textarea_${elem.id}`)
                if (textarea && textarea.length) {
                    textarea[0].focus()
                    textarea[0].selectionStart = start
                    textarea[0].selectionEnd = start + 1
                }
            }
            elem.constraintsOk = false
        }
        if (_.isObject(elem.constraints)) {
            elem.constraints = JSON.stringify(elem.constraints, null, 4)
            elem.constraintsOk = true
        }
    }

    const prettyPrintAll = (data) => _.each(data, $scope.prettyPrint)

    $scope.catchTab = function (id, event) {
        const keyCode = event.keyCode || event.which
        if (keyCode === 9) {
            const textarea = $(`#textarea_${id}`)
            event.preventDefault()
            const start = textarea[0].selectionStart
            const end = textarea[0].selectionEnd
            textarea.val(`${textarea.val().substring(0, start)}\t${textarea.val().substring(end)}`)
            textarea[0].selectionStart = start + 1
            textarea[0].selectionEnd = start + 1
        }
    }

    $scope.editMode = function (mod) {
        mod.editing = !mod.editing
        delete mod.edit
        mod.edit = angular.copy(mod)
    }

    $scope.cancelEditing = (mod) => {
        mod.editing = !mod.editing
    }

    $scope.save = function (mod) {
        $scope.prettyPrint(mod.edit, true)
        if (mod.edit.constraintsOk) {
            const payload = angular.copy(mod.edit)
            delete payload.id
            delete payload.editing
            delete payload.expanded
            delete payload.constraintsOk
            if (!payload.min_intermediate_billing_months) {
                payload.min_intermediate_billing_months = null
            }
            return DataAccess.updateModality({ id: mod.id }, payload).$promise.then(() => {
                AlertManager.success('Modalité modifiée')
                return $scope.refreshModalities() }).catch(ErrorCatcher)
        }
    }

    $scope.toggleExpand = function (mod) {
        if (!mod.editing) {
            mod.expanded = !mod.expanded
        }
    }

    // TEST MODALITIES
    $scope.contractPayload = {
        id_contract: '',
    }

    $scope.contractFields = {
        id_contract: {
            label: 'ID Contrat',
            required: true,
            type: 'text',
        },
    }

    $scope.testModalities = () =>
        ApiUser.computeBillingModality({ id_contract: $scope.contractPayload.id_contract, recompute: true }).$promise
        .then((result) => AlertManager.success(`Modalité choisie: ${result.computed.id}\n(${result.computed.label})`))
        .catch(ErrorCatcher)


    const activate = () => TableGeneratorService.getTable($scope.modalities, 'ref-billing-modality', undefined, prettyPrintAll, { orderBy: '-priority' })

    $scope.refreshModalities = activate
    activate()
})
